import {
  diaInterfaceTechOptions,
  eplAccessTechOptions,
  includedOptions,
} from "@/common/const/filter-options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { ResponseFormElementsType } from "@/common/types/forms/FormFieldsStrategy.type";

const eplResStrategy: ResponseFormElementsType[] = [
  {
    attribute: "bandWidth",
    type: "text",
    required: true,
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
    patternMessage: "Bandwidth must be a number between 0.128 and 10000",
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "select",
    attribute: "interface",
    required: false,
    options: diaInterfaceTechOptions,
  },
  {
    type: "select",
    attribute: "AccessTechnology",
    required: true,
    options: eplAccessTechOptions,
  },
  {
    type: "select",
    attribute: "qinqSupported",
    required: true,
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
  {
    type: "text",
    attribute: "cableProvider",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(?!\s*$).+/,
    patternMessage: "Cable provider cannot be empty",
  },
  {
    type: "select",
    attribute: "jumboFrames",
    required: true,
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
  {
    type: "select",
    attribute: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
  },
  {
    type: "text",
    attribute: "SlaUptime",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/,
    patternMessage: "Enter a number between 0 and 100",
  },
  {
    type: "text",
    attribute: "mtuSize",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d{3,5}$/,
    patternMessage: "MTU must be a number between 576 and 9216",
  },
  {
    type: "text",
    attribute: "SlaMTTR",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d{1,3}$/,
    patternMessage: "Enter MTTR in hours as a number",
  },
  {
    type: "select",
    attribute: "isLocalTax",
    required: true,
    options: includedOptions,
  },
  {
    type: "text",
    attribute: "slaLatency",
    required: true,
    pattern: /^\d{1,3}$/,
    patternMessage: "SLA Latency (in ms) as a number",
  },
  {
    type: "text",
    attribute: "localTax",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/,
    patternMessage: "Enter a number between 0 and 100",
  },
  {
    type: "text",
    attribute: "leadTeam",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d{1,3}$/,
    patternMessage: "Lead time must be a number (days)",
  },
];

export default eplResStrategy;
